// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   Search Sidebar — navigation rail (no product cards)
   ═══════════════════════════════════════════════════════════ */

.ss-pane {
  width: 220px;
  flex-shrink: 0;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
}
.ss-pane::-webkit-scrollbar { width: 3px; }
.ss-pane::-webkit-scrollbar-track { background: transparent; }
.ss-pane::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 4px; }

/* ── Fixed nav (Top Searches + Bundles) ─────────────────── */
.ss-fixed-nav {
  padding: 12px 8px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-bottom: 1px solid #e2e8f0;
}

/* ── Category section ───────────────────────────────────── */
.ss-cat-section {
  padding: 10px 8px 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.ss-cat-header {
  font-size: 9.5px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  margin: 0 0 8px 4px;
}

.ss-cat-loading {
  display: flex;
  justify-content: center;
  padding: 16px 0;
}

.ss-empty {
  font-size: 11px;
  color: #cbd5e1;
  margin: 0 0 0 4px;
  font-style: italic;
}

.ss-cat-list {
  display: flex;
  flex-direction: column;
  gap: 1px;
  overflow-y: auto;
  scrollbar-width: none;
}
.ss-cat-list::-webkit-scrollbar { display: none; }

/* ── Nav row (shared by all items) ─────────────────────── */
.ss-nav-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 9px 10px;
  border-radius: 9px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  position: relative;
  transition: background 0.14s ease;
}
.ss-nav-row:hover {
  background: #f1f5f9;
}
.ss-nav-row--active {
  background: #eff6ff;
}

.ss-nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  flex-shrink: 0;
  color: #94a3b8;
  transition: color 0.14s;
}
.ss-nav-row--active .ss-nav-icon { color: #2a71ff; }

/* category dot instead of svg icon */
.ss-nav-icon--dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #cbd5e1;
  margin-left: 4px;
  margin-right: 4px;
  flex-shrink: 0;
}
.ss-nav-row--active .ss-nav-icon--dot { background: #2a71ff; }

.ss-nav-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #475569;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.14s;
}
.ss-nav-row--active .ss-nav-label { color: #2a71ff; }

.ss-nav-active-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2a71ff;
  flex-shrink: 0;
}

/* ═══════════════════════════════════════════════════════════
   Dark mode
   ═══════════════════════════════════════════════════════════ */
.dark .ss-pane {
  background: #0a0f1e;
  border-right-color: #1e293b;
}
.dark .ss-fixed-nav     { border-bottom-color: #1e293b; }
.dark .ss-cat-header    { color: #334155; }
.dark .ss-empty         { color: #334155; }

.dark .ss-nav-row:hover    { background: #111827; }
.dark .ss-nav-row--active  { background: #0d1e3a; }

.dark .ss-nav-icon   { color: #475569; }
.dark .ss-nav-row--active .ss-nav-icon { color: #60a5fa; }

.dark .ss-nav-icon--dot { background: #334155; }
.dark .ss-nav-row--active .ss-nav-icon--dot { background: #60a5fa; }

.dark .ss-nav-label  { color: #64748b; }
.dark .ss-nav-row--active .ss-nav-label { color: #60a5fa; }

.dark .ss-nav-active-dot { background: #60a5fa; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/searchBar/SearchSidebar.css"],"names":[],"mappings":"AAAA;;gEAEgE;;AAEhE;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;AACtC;AACA,8BAA8B,UAAU,EAAE;AAC1C,oCAAoC,uBAAuB,EAAE;AAC7D,oCAAoC,mBAAmB,EAAE,kBAAkB,EAAE;;AAE7E,8DAA8D;AAC9D;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gCAAgC;AAClC;;AAEA,8DAA8D;AAC9D;EACE,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;AACvB;AACA,kCAAkC,aAAa,EAAE;;AAEjD,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;AACA,mCAAmC,cAAc,EAAE;;AAEnD,qCAAqC;AACrC;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA,wCAAwC,mBAAmB,EAAE;;AAE7D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,oCAAoC,cAAc,EAAE;;AAEpD;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;gEAEgE;AAChE;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA,0BAA0B,4BAA4B,EAAE;AACxD,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;;AAE1C,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;;AAElD,uBAAuB,cAAc,EAAE;AACvC,yCAAyC,cAAc,EAAE;;AAEzD,0BAA0B,mBAAmB,EAAE;AAC/C,8CAA8C,mBAAmB,EAAE;;AAEnE,uBAAuB,cAAc,EAAE;AACvC,0CAA0C,cAAc,EAAE;;AAE1D,2BAA2B,mBAAmB,EAAE","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   Search Sidebar — navigation rail (no product cards)\n   ═══════════════════════════════════════════════════════════ */\n\n.ss-pane {\n  width: 220px;\n  flex-shrink: 0;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-right: 1px solid #e2e8f0;\n  background: #f8fafc;\n  display: flex;\n  flex-direction: column;\n  scrollbar-width: thin;\n  scrollbar-color: #e2e8f0 transparent;\n}\n.ss-pane::-webkit-scrollbar { width: 3px; }\n.ss-pane::-webkit-scrollbar-track { background: transparent; }\n.ss-pane::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 4px; }\n\n/* ── Fixed nav (Top Searches + Bundles) ─────────────────── */\n.ss-fixed-nav {\n  padding: 12px 8px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n/* ── Category section ───────────────────────────────────── */\n.ss-cat-section {\n  padding: 10px 8px 12px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.ss-cat-header {\n  font-size: 9.5px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n  margin: 0 0 8px 4px;\n}\n\n.ss-cat-loading {\n  display: flex;\n  justify-content: center;\n  padding: 16px 0;\n}\n\n.ss-empty {\n  font-size: 11px;\n  color: #cbd5e1;\n  margin: 0 0 0 4px;\n  font-style: italic;\n}\n\n.ss-cat-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n.ss-cat-list::-webkit-scrollbar { display: none; }\n\n/* ── Nav row (shared by all items) ─────────────────────── */\n.ss-nav-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 9px 10px;\n  border-radius: 9px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  position: relative;\n  transition: background 0.14s ease;\n}\n.ss-nav-row:hover {\n  background: #f1f5f9;\n}\n.ss-nav-row--active {\n  background: #eff6ff;\n}\n\n.ss-nav-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  flex-shrink: 0;\n  color: #94a3b8;\n  transition: color 0.14s;\n}\n.ss-nav-row--active .ss-nav-icon { color: #2a71ff; }\n\n/* category dot instead of svg icon */\n.ss-nav-icon--dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #cbd5e1;\n  margin-left: 4px;\n  margin-right: 4px;\n  flex-shrink: 0;\n}\n.ss-nav-row--active .ss-nav-icon--dot { background: #2a71ff; }\n\n.ss-nav-label {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #475569;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: color 0.14s;\n}\n.ss-nav-row--active .ss-nav-label { color: #2a71ff; }\n\n.ss-nav-active-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #2a71ff;\n  flex-shrink: 0;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Dark mode\n   ═══════════════════════════════════════════════════════════ */\n.dark .ss-pane {\n  background: #0a0f1e;\n  border-right-color: #1e293b;\n}\n.dark .ss-fixed-nav     { border-bottom-color: #1e293b; }\n.dark .ss-cat-header    { color: #334155; }\n.dark .ss-empty         { color: #334155; }\n\n.dark .ss-nav-row:hover    { background: #111827; }\n.dark .ss-nav-row--active  { background: #0d1e3a; }\n\n.dark .ss-nav-icon   { color: #475569; }\n.dark .ss-nav-row--active .ss-nav-icon { color: #60a5fa; }\n\n.dark .ss-nav-icon--dot { background: #334155; }\n.dark .ss-nav-row--active .ss-nav-icon--dot { background: #60a5fa; }\n\n.dark .ss-nav-label  { color: #64748b; }\n.dark .ss-nav-row--active .ss-nav-label { color: #60a5fa; }\n\n.dark .ss-nav-active-dot { background: #60a5fa; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
